'use strict';

var form = document.getElementById('checkout-form');
var clampTimeout;
var errorContainer = $('.checkout-widget .error-container');
var orderErrorContainer = $('.checkout-widget .order-error');
var quantityInput = $('.checkout-widget .quantity-input').first();
var spinnerHtml = '<span class="pd-spinner" aria-hidden="true"></span><span class="pd-spinner-text">Processing...</span>';

// Last successful estimate response. Kept so a failed re-query can leave the
// previous (correct) figures on screen instead of blanking the summary to $0.00.
var lastEstimate = null;

function ensureSpinnerStyle() {
  if (document.getElementById('pd-spinner-style')) return;
  var css = '\n    .pd-spinner{display:inline-block;width:18px;height:18px;border:2px solid rgba(0,0,0,0.12);border-top-color:#000;border-radius:50%;animation:pd-spin 0.6s linear infinite;vertical-align:middle;margin-right:8px;}\n    .pd-spinner-text{vertical-align:middle;}\n    @keyframes pd-spin{to{transform:rotate(360deg)}}\n  ';
  var style = document.createElement('style');
  style.id = 'pd-spinner-style';
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
}

function disableSecondButton(btn) {
  ensureSpinnerStyle();
  // store original content so we can restore it later
  if (!btn.data('original-html')) {
    btn.data('original-html', btn.html());
  }
  btn.prop('disabled', true);
  btn.addClass('disabled');
  btn.attr('aria-busy', 'true');
  btn.html(spinnerHtml);
}

function restoreSecondButton(btn) {
  var original = btn.data('original-html');
  if (original !== undefined) {
    btn.html(original);
    btn.removeData('original-html');
  }
  btn.prop('disabled', false);
  btn.removeClass('disabled');
  btn.removeAttr('aria-busy');
}


$(document).ready(function () {
  initialize();
  registerButtons();
  registerExpiryFormatting();
  registerPhoneFormatting();
  initializeSummaryToggle();
  registerCvcTooltip();
  initializeExtraItems();
});

/**
 * Optional add-on items (one-time gift, and later bonus/upsell asks) declare
 * themselves in the markup with [data-extra-item] plus data-sku / data-quantity /
 * data-role / data-label, and optionally data-amount. Selection lives entirely in
 * the DOM, so a new kind of ask can be added to the template without touching this
 * file.
 *
 * data-amount means "price this line at this dollar value rather than the catalog
 * price". Gifts use it, because one generic donation SKU carries every gift size.
 * A bonus or upsell with a real catalog price simply omits it.
 *
 * @returns {Array} selected items, in the shape the widget endpoints expect
 */
function getExtraItems() {
  var items = [];

  $('.checkout-widget [data-extra-item].selected').each(function () {
    var el = $(this);
    var item = {
      sku: el.data('sku'),
      quantity: parseInt(el.data('quantity'), 10) || 1,
      role: el.data('role') || 'extra'
    };

    // An element that declares data-amount is custom-priced by definition. If the
    // value is unusable, skip the item rather than sending it without one - that
    // would silently fall through to catalog pricing and charge the wrong figure.
    if (el.is('[data-amount]')) {
      var amount = parseFloat(el.attr('data-amount'));
      if (isNaN(amount) || amount <= 0) {
        return;
      }
      item.amount = amount;
    }

    items.push(item);
  });

  return items;
}

/**
 * Syncs the gift confirmation row to whatever is currently selected in the DOM.
 * Local state, so it repaints immediately - only the summary figures wait on the
 * server.
 */
function renderOtgConfirmation() {
  var otgAsk = $('.checkout-widget .otg-ask');
  if (!otgAsk.length) return;

  var selected = otgAsk.find('.otg-amount-button.selected').first();

  if (selected.length) {
    otgAsk.find('.otg-selected-amount').text(selected.data('amount'));
    otgAsk.find('.otg-confirmation').show();
  } else {
    otgAsk.find('.otg-confirmation').hide();
  }
}

/**
 * Clears the selection on add-ons the server reported it could not add.
 *
 * @param {Array} skippedSkus - SKUs from the endpoint's skippedSkus
 * @returns {boolean} true if anything was deselected
 */
function deselectSkippedItems(skippedSkus) {
  if (!skippedSkus || !skippedSkus.length) return false;

  var changed = false;

  $('.checkout-widget [data-extra-item].selected').each(function () {
    var el = $(this);
    if (skippedSkus.indexOf(el.data('sku')) !== -1) {
      el.removeClass('selected').attr('aria-pressed', 'false');
      changed = true;
    }
  });

  if (changed) {
    renderOtgConfirmation();
  }

  return changed;
}

function initializeExtraItems() {
  var otgAsk = $('.checkout-widget .otg-ask');
  if (!otgAsk.length) return;

  var amountButtons = otgAsk.find('.otg-amount-button');

  amountButtons.on('click', function () {
    var btn = $(this);
    var wasSelected = btn.hasClass('selected');

    amountButtons.removeClass('selected').attr('aria-pressed', 'false');

    // Clicking the active amount clears the gift.
    if (!wasSelected) {
      btn.addClass('selected').attr('aria-pressed', 'true');
    }

    renderOtgConfirmation();
    requeryEstimate();
  });

  otgAsk.find('.otg-remove').on('click', function () {
    amountButtons.removeClass('selected').attr('aria-pressed', 'false');
    renderOtgConfirmation();
    requeryEstimate();
  });
}

/**
 * Re-prices the basket after an add-on changes. Add-ons can be taxed and/or
 * shippable, so the server has to recalculate rather than the client adding a
 * number to the total.
 */
function requeryEstimate() {
  if (typeof window.maybeQueryNow === 'function') {
    window.maybeQueryNow();
  }
}
// Tooltip for CVC icon
function registerCvcTooltip() {
  var $icon = $('.cvc-icon');
  var $tooltip = $('.cvc-tooltip');
  if (!$icon.length || !$tooltip.length) return;

  function showTooltip() {
    $tooltip.stop(true, true).fadeIn(120);
  }
  function hideTooltip() {
    $tooltip.stop(true, true).fadeOut(120);
  }

  $icon.on('mouseenter focus', showTooltip);
  $icon.on('mouseleave blur', hideTooltip);
  // Also allow keyboard users to tab to the icon
  $icon.attr('tabindex', 0);
}

function initialize() {
  $('.checkout-widget .section-two').hide();
  $('.checkout-widget .section-three').hide();

  // Setup billing address toggle
  var useSameCheckbox = $('#useSameAsBilling');
  var billingAddressSection = $('.checkout-widget .billing-address-section');
  var billingNameSection = $('.checkout-widget .billing-name-section');
  var billingSectionTitle = $('.checkout-widget .billing-section-title');

  function updateBillingVisibility() {
    var isChecked = useSameCheckbox.is(':checked');
    if (isChecked) {
      // Hide billing fields
      billingAddressSection.slideUp(200);
      billingNameSection.slideUp(200);
      billingSectionTitle.slideUp(150);
      // Remove required attribute
      billingAddressSection.find('[required]').removeAttr('required');
      billingNameSection.find('[required]').removeAttr('required');
    } else {
      // Show billing fields
      billingSectionTitle.slideDown(150);
      billingAddressSection.slideDown(200);
      billingNameSection.slideDown(200);
      // Add required attribute (address line 2 stays optional)
      billingAddressSection.find('input[name^="billing"]').not('[name="billingAddress2"]').attr('required', 'required');
      billingNameSection.find('input[name^="billing"]').attr('required', 'required');
    }
  }

  useSameCheckbox.on('change', updateBillingVisibility);

  // Remember checkbox state in localStorage
  // var savedCheckboxState = localStorage.getItem('checkoutWidget-useSameAsBilling');
  // if (savedCheckboxState !== null) {
  //   useSameCheckbox.prop('checked', savedCheckboxState === 'true');
  // }
  updateBillingVisibility();

  // useSameCheckbox.on('change', function () {
  //   localStorage.setItem('checkoutWidget-useSameAsBilling', $(this).is(':checked'));
  // });
}

function validateForm() {
  // reset any messages
  orderErrorContainer.html('');
  orderErrorContainer.addClass('hidden');
  errorContainer.html('');
  errorContainer.addClass('hidden');
  $('.checkout-widget .user-info').removeClass('is-invalid');
  $('.checkout-widget .cc-info').removeClass('is-invalid');

  if (!form.checkValidity()) {
    // find the first invalid field and show its message
    var invalid = form.querySelector(':invalid');
    invalid.focus();
    errorContainer.removeClass('hidden');
    errorContainer.html('Please fill in all required fields');
    return false;
  }

  var exp = form.elements['expiry'].value;
  // Accept M/YY, MM/YY, M/Y or MM/Y where month is 1-12 and year is 1-2 digits
  if (!/^(0?[1-9]|1[0-2])\/\d{1,2}$/.test(exp)) {
    form.elements['expiry'].focus();
    errorContainer.removeClass('hidden');
    errorContainer.html('Expiry must be in MM/YY format.');
    return false;
  }

  var cvc = form.elements['cvc'].value;
  if (!/^\d{3,4}$/.test(cvc)) {
    form.elements['cvc'].focus();
    errorContainer.removeClass('hidden');
    errorContainer.html('CVC must be 3 or 4 digits.');
    return false;
  }

  return true;
}

function validateAddress() {
  // reset any messages
  $('.checkout-widget .user-info').removeClass('is-invalid');
  $('.checkout-widget .cc-info').removeClass('is-invalid');
  errorContainer.html('');
  errorContainer.addClass('hidden');

  var address = parseFloat(donateInput.value);
  if (isNaN(amt) || amt < 10) {
    donateInput.focus();
    errorContainer.removeClass('hidden');
    errorContainer.html('Please enter an amount of at least $10.');
    return false;
  }
  return true;
}

function registerButtons() {
  var first = $('.checkout-widget .firstButton').first();
  var second = $('.checkout-widget .secondButton').first();
  var back = $('.checkout-widget .backButton').first();
  var plus = $('.checkout-widget .plus').first();
  var minus = $('.checkout-widget .minus').first();

  var msgEl = document.getElementById('order-message');


  //on click, move to next stage
  first.click(function () {
    var btn = $(this);
    if (btn.hasClass('disabled') || btn.attr('aria-disabled') === 'true') return;
    var fd = new FormData(form);
    var data = populateFormData(fd);
    var validated = validateAddressForm(data);
    if (validated) {
      $('.checkout-widget .section-one').hide();
      $('.checkout-widget .section-two').show();
      copyValuesToBilling();
      $('.checkout-widget .tab-two').addClass('selected');
      $('.checkout-widget .tab-one').removeClass('selected');

    }


  });

  // keyboard support for firstButton
  first.keydown(function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      first.click();
    }
  });

  back.click(function (e) {
    e.preventDefault();
    $('.checkout-widget .section-one').show();
    $('.checkout-widget .section-two').hide();
    $('.checkout-widget .tab-two').removeClass('selected');
    $('.checkout-widget .tab-one').addClass('selected');
  });


  //on click, checkout
  second.click(function () {
    var btn = $(this);
    if (btn.hasClass('disabled') || btn.attr('aria-disabled') === 'true') return;
    var validated = validateForm();
    var fd = new FormData(form);
    var data = populateFormData(fd);
    const urlEncoded = new URLSearchParams(data).toString();
    var checkoutOrderUrl = $('.checkout-place-order-url').val();
    if (validated) {
      // prevent double submissions by disabling the button and showing a spinner until we get a response
      disableSecondButton(second);

      fetch(checkoutOrderUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: urlEncoded
      })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          if (json.success) {

            try {              
              $('.checkout-widget .section-three').show();
              $('.checkout-widget .section-two').hide();

              // search .section-three for '{{orderNumber}}' and replace with json.orderNumber
              $('.checkout-widget .section-three').find('*').each(function () {
                if (typeof $(this).html() === 'string' && $(this).html().indexOf('{{orderNumber}}') !== -1) {
                  $(this).html($(this).html().replace(/{{orderNumber}}/g, json.orderNumber));
                }
              });

            } catch (error) {
              //do nothing
              console.log(error);

              if (window.dataLayerHandler) {
                var errorMsgs = [
                  'On-page checkout error',
                  error.message || 'Unknown error'
                ]
                dataLayerHandler.pushToDataLayerWithClient({
                    event: 'checkoutError',
                    ecommerce: {
                        checkout: {
                            errors: errorMsgs,
                        },
                    },
                });
              }
            }
            
          } else {
            msgEl.textContent = 'Error: ' + (json.error || 'Could not add to cart');
          }
          msgEl.classList.remove('hidden');
          // restore the button when we have a response
          restoreSecondButton(second);
        })
        .catch(function () {
          orderErrorContainer.html('We ran into an error making your order. Please check the information above and try again');
          orderErrorContainer.removeClass('hidden');
          // restore the button after an error so user can retry
          restoreSecondButton(second);
        });
    }
  })

  // keyboard support for secondButton
  second.keydown(function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      second.click();
    }
  });

  // Helper to trigger tax/shipping update if available
  function triggerQuantityUpdate() {
    // ...existing code...
    maybeQuery();
  }

  plus.click(function () {
    // ...existing code...
    quantityInput.val(parseInt(quantityInput.val()) + 1);
    triggerQuantityUpdate();
  });

  minus.click(function () {
    // ...existing code...
    var current = parseInt(quantityInput.val(), 10) || 1;
    if (current > 1) {
      quantityInput.val(current - 1);
      triggerQuantityUpdate();
    }
  });

  // prevent manual input from going below 1 and trigger update
  quantityInput.on('input change', function () {
    var val = parseInt($(this).val(), 10);
    if (isNaN(val) || val < 1) {
      $(this).val(1);
    }
    triggerQuantityUpdate();
  });

  // Credit card number: accept only digits and format with appropriate spacing
  var cardNumberInput = $('input[name="cardNumber"]').first();
  
  function getCardType(cardNumber) {
    // Check patterns in a specific order (most specific first)
    if (/^3[47]/.test(cardNumber)) return 'amex';
    if (/^(5[1-5]|2[2-7])/.test(cardNumber)) return 'mastercard';
    if (/^4/.test(cardNumber)) return 'visa';
    return 'default';
  }
  
  function formatCardNumber(digitsOnly) {
    var cardType = getCardType(digitsOnly);
    var formatted = '';
    
    switch(cardType) {
      case 'amex':
        // American Express: 4-6-5 pattern (15 digits)
        formatted = digitsOnly.slice(0, 4);
        if (digitsOnly.length > 4) {
          formatted += ' ' + digitsOnly.slice(4, 10);
        }
        if (digitsOnly.length > 10) {
          formatted += ' ' + digitsOnly.slice(10, 15);
        }
        break;
      case 'visa':
      case 'mastercard':
      default:
        // Standard 4-4-4-4 pattern
        formatted = digitsOnly.slice(0, 4);
        if (digitsOnly.length > 4) formatted += ' ' + digitsOnly.slice(4, 8);
        if (digitsOnly.length > 8) formatted += ' ' + digitsOnly.slice(8, 12);
        if (digitsOnly.length > 12) formatted += ' ' + digitsOnly.slice(12, 19);
        break;
    }
    
    return formatted;
  }
  
  var cardValidationTimeout;
  cardNumberInput.on('input', function () {
    var $el = $(this);
    var val = $el.val();
    // Strip all non-digit characters
    var digitsOnly = val.replace(/\D/g, '');
    // Limit to 19 digits (longest card number possible)
    if (digitsOnly.length > 19) {
      digitsOnly = digitsOnly.slice(0, 19);
    }
    // Format with appropriate spacing
    var formatted = formatCardNumber(digitsOnly);
    if (val !== formatted) {
      $el.val(formatted);
    }

    //No debounce needed if empty: clear invalid state immediately
    if (digitsOnly.length === 0) {
      setFieldValidity($el[0], true);
    }

    // Debounced validation for invalid state
    clearTimeout(cardValidationTimeout);
    cardValidationTimeout = setTimeout(function () {
      if (digitsOnly.length < 13) {
        setFieldValidity($el[0], false);
      } else {
        setFieldValidity($el[0], true);
      }
    }, 1000);
  });

  // Handle paste: ensure pasted content is normalized, formatted and validated
  cardNumberInput.on('paste', function (e) {
    // prevent the default paste handling
    e.preventDefault();
    var rawEvent = e.originalEvent || e;
    var clipboard = (rawEvent.clipboardData || window.clipboardData);
    var pasted = '';
    try {
      pasted = clipboard && clipboard.getData ? clipboard.getData('text') : '';
    } catch (err) {
      // fallback for older browsers
      try { pasted = window.clipboardData && window.clipboardData.getData('Text') || ''; } catch (e) { pasted = ''; }
    }

    // Keep only digits and limit to 19
    var digitsOnly = (pasted || '').replace(/\D/g, '').slice(0, 19);

    // Format the digits for display
    var formatted = formatCardNumber(digitsOnly);
    $(this).val(formatted);

    // Trigger input event so other handlers (like button state updates) run
    $(this).trigger('input');

    // Run the existing validation function to validate the pasted value
    try {
      validateForm();
    } catch (ex) {
      // swallow errors if validateForm isn't available in scope for some reason
    }

    // update CTAs state if available
    try {
      updateButtonsState();
    } catch (err) {
      // it's okay if updateButtonsState is not accessible from here
    }
  });

  // Helper to toggle per-field invalid state (adds class + aria attribute)
  function setFieldValidity(el, isValid) {
    if (!el) return;
    // Special handling for card number: don't show invalid if empty
    if (el.name === 'cardNumber') {
      if (el.value.trim() === '') {
        el.classList.remove('is-invalid');
        el.removeAttribute('aria-invalid');
        return;
      }
    }
    if (isValid) {
      el.classList.remove('is-invalid');
      el.removeAttribute('aria-invalid');
    } else {
      el.classList.add('is-invalid');
      el.setAttribute('aria-invalid', 'true');
    }
  }

  // Validate expiry and cvc on blur (show invalid styling after user finishes)
  var expiryEl = form.elements['expiry'];
  var cvcEl = form.elements['cvc'];
  if (expiryEl) {
    expiryEl.addEventListener('blur', function () {
      var val = (expiryEl.value || '').trim();
      // Accept M/YY, MM/YY, M/Y or MM/Y where month is 1-12 and year is 1-2 digits
      var ok = /^(0?[1-9]|1[0-2])\/\d{1,2}$/.test(val);
      setFieldValidity(expiryEl, ok);
      try { updateButtonsState(); } catch (e) {}
    });
    expiryEl.addEventListener('input', function () {
      // remove invalid state while user types
      expiryEl.classList.remove('is-invalid');
      expiryEl.removeAttribute('aria-invalid');
    });
  }
  if (cvcEl) {
    cvcEl.addEventListener('blur', function () {
      var val = (cvcEl.value || '').trim();
      var ok = /^\d{3,4}$/.test(val);
      setFieldValidity(cvcEl, ok);
      try { updateButtonsState(); } catch (e) {}
    });
    cvcEl.addEventListener('input', function () {
      // remove invalid state while user types
      cvcEl.classList.remove('is-invalid');
      cvcEl.removeAttribute('aria-invalid');
    });
  }

  // Helper: enable/disable an anchor-styled button for accessibility
  function setButtonEnabled($btn, enabled) {
    if (!$btn || !$btn.length) return;
    if (enabled) {
      $btn.removeClass('disabled');
      $btn.prop('aria-disabled', false);
      $btn.attr('tabindex', '0');
      $btn.removeAttr('aria-disabled');
      $btn.prop('disabled', false);
    } else {
      $btn.addClass('disabled');
      $btn.prop('disabled', true);
      $btn.attr('aria-disabled', 'true');
      $btn.attr('tabindex', '-1');
    }
  }

  // Validate visible inputs within a section
  function isSectionValid(sectionSelector) {
    var section = document.querySelector(sectionSelector);
    if (!section) return false;
    var inputs = section.querySelectorAll('input, select, textarea');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      // only check required, not disabled, and visible elements
      if (el.required && !el.disabled && el.offsetParent !== null) {
        if (!el.checkValidity()) return false;
      }
    }
    return true;
  }

  // Silent validation for section-one: matches validateAddressForm checks without mutating DOM
  function isAddressSectionValid() {
    var fd = new FormData(form);
    var data = populateFormData(fd);

    if (!data.shippingAddress1 || data.shippingAddress1 === '') return false;
    if (!data.shippingZip || data.shippingZip === '') return false;
    if (!data.shippingFirstName || data.shippingFirstName === '') return false;
    if (!data.shippingLastName || data.shippingLastName === '') return false;
    if (!data.phone || data.phone === '') return false;
    if (!data.email || data.email === '') return false;

    // basic HTML5 validity for other visible required inputs
    return isSectionValid('.checkout-widget .section-one');
  }

  // Silent validation for payment section: matches validateForm checks without showing errors
  function isPaymentSectionValid() {
    // Skip billing validation if using same as shipping
    var useSame = $('#useSameAsBilling').is(':checked');
    
    // For visible required inputs, skip billing fields if using same as shipping
    var section = document.querySelector('.checkout-widget .section-two');
    if (!section) return false;
    var inputs = section.querySelectorAll('input, select, textarea');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      // Skip billing address/name fields if using same as shipping
      if (useSame && (el.name.startsWith('billing') && !el.name.startsWith('billingFirstName') && !el.name.startsWith('billingLastName'))) {
        continue;
      }
      // Avoid calling native checkValidity on expiry and cvc here because
      // we validate those with custom regex below. Calling checkValidity()
      // can cause the browser to apply :invalid styling while the user is
      // still typing (showing a red outline). Skip native validation for
      // these two fields and rely on the explicit regex checks later.

      if (el.name === 'expiry' || el.name === 'cvc' || el.name === 'cardNumber') {
        continue;
      }

      // Check required, not disabled, and visible elements
      if (el.required && !el.disabled && el.offsetParent !== null) {
        if (!el.checkValidity()) return false;
      }
    }

    // check expiry format MM/YY
    var expEl = form.elements['expiry'];
    if (!expEl) return false;
    var exp = (expEl.value || '').trim();
    // Accept M/YY, MM/YY, M/Y or MM/Y where month is 1-12 and year is 1-2 digits
    if (!/^(0?[1-9]|1[0-2])\/\d{1,2}$/.test(exp)) return false;

    // check CVC
    var cvcEl = form.elements['cvc'];
    if (!cvcEl) return false;
    var cvc = (cvcEl.value || '').trim();
    if (!/^\d{3,4}$/.test(cvc)) return false;

    return true;
  }

  // Update CTAs based on the current validity of each section
  function updateButtonsState() {
    // first button corresponds to section-one
    var firstValid = isAddressSectionValid();
    setButtonEnabled(first, firstValid);

    // second button corresponds to section-two
    var secondValid = isPaymentSectionValid();
    setButtonEnabled(second, secondValid);
  }

  // Recompute button states when inputs change
  $(form).on('input change', 'input, select, textarea', function () {
    // small debounce to avoid excessive calls
    clearTimeout(clampTimeout);
    clampTimeout = setTimeout(updateButtonsState, 50);
  });

  // run once to set initial state
  updateButtonsState();
}

function populateFormData(fd) {
  var shippingAddress = fd.get('shippingAddress');
  var shippingAddress2 = fd.get('shippingAddress2');
  var shippingZip = fd.get('shippingZip');
  var shippingCountry = fd.get('shippingCountry');
  var shippingFirstName = fd.get('shippingFirstName');
  var shippingLastName = fd.get('shippingLastName');
  var billingAddress = fd.get('billingAddress');
  var billingAddress2 = fd.get('billingAddress2');
  var billingZip = fd.get('billingZip');
  var billingCountry = fd.get('billingCountry');
  var billingFirstName = fd.get('billingFirstName');
  var billingLastName = fd.get('billingLastName');
  var email = fd.get('email');
  var phone = fd.get('phone');
  var cardNum = fd.get('cardNumber');
  var expiry = fd.get('expiry');
  var cvc = fd.get('cvc');
  var productSKU = fd.get('productId');

  var data = {
    shippingAddress1: shippingAddress,
    shippingAddress2: shippingAddress2,
    shippingZip: shippingZip,
    shippingCountry: shippingCountry,
    email: email,
    phone: phone,
    shippingFirstName: shippingFirstName,
    shippingLastName: shippingLastName,
    billingAddress1: billingAddress,
    billingAddress2: billingAddress2,
    billingZip: billingZip,
    billingCountry: billingCountry,
    billingFirstName: billingFirstName,
    billingLastName: billingLastName,
    cardNum: cardNum,
    expires: expiry,
    cvv: cvc,
    productSKU: productSKU,
    quantity: parseInt(quantityInput.val()),
    // Same payload shape the estimate endpoint receives, so the shopper is
    // charged for exactly what the summary showed.
    extraItems: JSON.stringify(getExtraItems())
  };
  return data;
}


function registerExpiryFormatting() {
  var expiry = document.querySelector('input[name="expiry"], #expiry');
  if (!expiry) return;

  // Format on every input, unless skipFormat was set by Backspace
  expiry.addEventListener('input', function (e) {

    if (e.data == null) {
      // consume the flag and do not format on this input
      return;
    }

    var raw = expiry.value || '';
    // Keep only digits
    var digits = raw.replace(/\D/g, '');

    if (digits.length === 0) {
      expiry.value = '';
      return;
    }

    // Limit to max 4 digits (MMYY)
    if (digits.length > 4) digits = digits.slice(0, 4);

      // If there's only one digit entered
      if (digits.length === 1) {
        var d = digits[0];
        if (d === '0') {
          // If the user typed '0' first, do not prepend another 0 or add a slash yet.
          expiry.value = '0';
        } else if (d !== '1') {
          // For single-digit months other than '1' (and not '0'), prepend a leading zero and add slash
          expiry.value = '0' + d + '/';
        } else {
          // this adds a leading zero for '1' if a slash is added after a 1
          if (e.data === '/') {
            expiry.value = '01/';
          }
          // if input is not a slash keep '1' as-is to allow user to type second digit (e.g., to form 10,11,12)
        }
        return;
      }


      // When two or more digits exist, ensure a slash after the month
      var month = digits.slice(0, 2);
      var year = digits.slice(2);

      // If month is '00', change to '01'
      if (month === '00') {
        month = '01';
      }else if (parseInt(month, 10) > 12) {
        // If month is greater than 12, set to '12'
        month = '12';
      }

      var formatted = month + '/';
      if (year.length > 0) formatted += year;

      expiry.value = formatted;
  });
}

/**
 * Shows the phone number as (XXX) XXX-XXXX without changing what gets submitted.
 *
 * The visible input (#phoneDisplay) holds the formatted string but has no name, so
 * the form never sends it. Every keystroke is mirrored as bare digits into the hidden
 * input[name="phone"], which is what populateFormData and the tax-estimate calls read -
 * they keep receiving an unformatted number, exactly as before.
 */
function registerPhoneFormatting() {
  var display = document.getElementById('phoneDisplay');
  var hidden = form && form.elements['phone'];
  if (!display || !hidden) return;

  /**
   * Separators are only added once the digits that follow them exist. Adding them
   * eagerly (e.g. showing "(555) " after three digits) makes Backspace unusable:
   * the delete removes the trailing separator and the reformat puts it straight back.
   *
   * @param {string} digits up to 10 digits
   * @returns {string} the digits as much of (XXX) XXX-XXXX as they fill
   */
  function formatPhone(digits) {
    if (digits.length === 0) return '';
    if (digits.length <= 3) return '(' + digits;
    if (digits.length <= 6) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
  }

  function sync() {
    var digits = (display.value || '').replace(/\D/g, '');

    // Autofill often supplies a country code (+1 555 ...). Drop it rather than
    // truncating the last digit off a real number.
    if (digits.length === 11 && digits.charAt(0) === '1') {
      digits = digits.slice(1);
    }
    if (digits.length > 10) digits = digits.slice(0, 10);

    display.value = formatPhone(digits);
    hidden.value = digits;
  }

  display.addEventListener('input', sync);
  // Autofill and other programmatic changes do not reliably fire 'input'.
  display.addEventListener('change', sync);
  display.addEventListener('blur', sync);

  // Catch a value the browser restored before this ran.
  sync();
}

function validateAddressForm(fd) {
  // reset any messages
  orderErrorContainer.html('');
  orderErrorContainer.addClass('hidden');
  errorContainer.html('');
  errorContainer.addClass('hidden');
  $('.checkout-widget .user-info').removeClass('is-invalid');
  $('.checkout-widget .cc-info').removeClass('is-invalid');

  if (fd.shippingAddress1 === '') {
    showShippingError("Please fill in all fields");
    return false;

  }
  if (fd.shippingZip === '') {
    showShippingError("Please fill in all fields");
    return false;

  }
  if (fd.shippingFirstName === '') {
    showShippingError("Please fill in all fields");
    return false;

  }
  if (fd.shippingLastName === '') {
    showShippingError("Please fill in all fields");
    return false;

  }
  if (fd.phone === '') {
    showShippingError("Please fill in all fields");
    return false;

  }
  if (fd.email === '') {
    showShippingError("Please fill in all fields");
    return false;
  }

  return true;
}


function showShippingError(msg) {
  errorContainer.html(msg);
  errorContainer.removeClass('hidden');
}

function copyValuesToBilling() {
  // Only copy if using same as shipping
  if (!$('#useSameAsBilling').is(':checked')) return;

  var fd = new FormData(form);
  var shippingAddress = fd.get('shippingAddress');
  var shippingAddress2 = fd.get('shippingAddress2');
  var shippingZip = fd.get('shippingZip');
  var shippingCountry = fd.get('shippingCountry');
  var shippingFirstName = fd.get('shippingFirstName');
  var shippingLastName = fd.get('shippingLastName');

  $('#billingAddress').val(shippingAddress).trigger('input').trigger('change');
  $('#billingAddress2').val(shippingAddress2).trigger('input').trigger('change');
  $('#billingZip').val(shippingZip).trigger('input').trigger('change');
  $('#billingCountry').val(shippingCountry).trigger('change');
  $('#billingFirstName').val(shippingFirstName).trigger('input').trigger('change');
  $('#billingLastName').val(shippingLastName).trigger('input').trigger('change');
}

// Summary Section Toggle and Calculations
function initializeSummaryToggle() {
  var summaryHeader = $('.checkout-widget .summary-header');
  var summaryContent = $('.checkout-widget .summary-content');
  var summaryToggleIcon = $('.checkout-widget .summary-toggle-icon');
  var summaryHeaderTotal = $('.checkout-widget .summary-header-total');
  var storageKey = 'checkoutWidget-summaryExpanded';

  // Check localStorage for saved state, default to collapsed (false)
  var isSummaryExpanded = localStorage.getItem(storageKey) === 'true';

  // Set initial state
  if (!isSummaryExpanded) {
    summaryContent.addClass('collapsed');
    summaryToggleIcon.addClass('collapsed');
    summaryHeaderTotal.show();
  } else {
    summaryHeaderTotal.hide();
  }

  // Toggle on header click
  summaryHeader.on('click', function () {
    summaryContent.toggleClass('collapsed');
    summaryToggleIcon.toggleClass('collapsed');

    // Show total only when collapsed
    if (summaryContent.hasClass('collapsed')) {
      summaryHeaderTotal.show();
    } else {
      summaryHeaderTotal.hide();
    }

    // Save state to localStorage
    var isNowExpanded = !summaryContent.hasClass('collapsed');
    localStorage.setItem(storageKey, isNowExpanded);
  });

  // Update summary values initially
  renderSummary(null);

  // --- TAX/SHIPPING QUERY LOGIC ---
  // Helper: show skeleton loading on summary
  function setSummarySkeletonLoading(isLoading) {
    var $summary = $('.checkout-widget .summary-content');
    var $headerTotal = $('.checkout-widget .summary-header-total');
    if (isLoading) {
      if (!$summary.hasClass('skeleton-loading')) {
        $summary.addClass('skeleton-loading');
        $summary.find('.summary-item .summary-value').each(function () {
          $(this).addClass('skeleton-box');
        });
      }
      $headerTotal.addClass('skeleton-box');
    } else {
      $summary.removeClass('skeleton-loading');
      $summary.find('.summary-item .summary-value').removeClass('skeleton-box');
      $headerTotal.removeClass('skeleton-box');
    }
  }

  // Add minimal skeleton CSS if not present
  if (!document.getElementById('summary-skeleton-style')) {
    var style = document.createElement('style');
    style.id = 'summary-skeleton-style';
    style.textContent = '.skeleton-box { background: linear-gradient(90deg, #eee 25%, #f5f5f5 50%, #eee 75%); border-radius: 4px; min-width: 40px; min-height: 1em; color: transparent !important; animation: skeleton-loading 1.2s infinite linear; } @keyframes skeleton-loading { 0% { background-position: -100px 0; } 100% { background-position: 140px 0; } }';
    document.head.appendChild(style);
  }

  // Helper: get all required values
  function getTaxShippingFields() {
    var useSame = $('#useSameAsBilling').is(':checked');
    var billingAddress = $('#billingAddress').val();
    var billingZip = $('#billingZip').val();
    var billingCountry = $('#billingCountry').val();
    // If using same as shipping, use shipping values if billing is empty
    if (useSame) {
      var shippingAddress = $('input[name="shippingAddress"]').val();
      var shippingZip = $('input[name="shippingZip"]').val();
      var shippingCountry = $('#shippingCountry').val();
      if (!billingAddress) billingAddress = shippingAddress;
      if (!billingZip) billingZip = shippingZip;
      if (!billingCountry) billingCountry = shippingCountry;
    }
    return {
      billingAddress: billingAddress,
      billingZip: billingZip,
      billingCountry: billingCountry,
      quantity: parseInt($('.checkout-widget .quantity-input').val(), 10),
      sku: $('input.productId').val(),
      extraItems: getExtraItems()
    };
  }

  // Helper: check if all required fields are present
  function hasAllTaxShippingFields(fields) {
    return fields.billingAddress && fields.billingZip && fields.billingCountry && fields.quantity && fields.sku;
  }

  // Monotonic request token. Selecting $20 then $50 quickly fires two requests;
  // without this the slower (stale) response can land last and show the wrong total.
  var estimateRequestId = 0;

  // Real queryTaxAndShipping: calls WidgetGetTaxEstimate endpoint
  function queryTaxAndShipping(fields, callback) {
    setSummarySkeletonLoading(true);
    estimateRequestId += 1;
    var requestId = estimateRequestId;
    // Prepare addresses as objects
    var billingAddress = {
      firstName: $('input[name="billingFirstName"]').val(),
      lastName: $('input[name="billingLastName"]').val(),
      address1: $('#billingAddress').val(),
      address2: $('#billingAddress2').val(),
      city: $('#billingCity').val(),
      stateCode: $('#billingState').val(),
      postalCode: $('#billingZip').val(),
      countryCode: $('#billingCountry').val(),
      phone: $('input[name="phone"]').val()
    };
    var shippingAddress = {
      firstName: $('input[name="shippingFirstName"]').val(),
      lastName: $('input[name="shippingLastName"]').val(),
      address1: $('input[name="shippingAddress"]').val(),
      address2: $('input[name="shippingAddress2"]').val(),
      city: $('#shippingCity').val(),
      stateCode: $('#shippingState').val(),
      postalCode: $('input[name="shippingZip"]').val(),
      countryCode: $('#shippingCountry').val(),
      phone: $('input[name="phone"]').val()
    };

    var taxEstimateUrl = $('.checkout-tax-estimate-url').val();
    $.ajax({
      url: taxEstimateUrl,
      method: 'POST',
      data: {
        billingAddress: JSON.stringify(billingAddress),
        shippingAddress: JSON.stringify(shippingAddress),
        quantity: fields.quantity,
        sku: fields.sku,
        extraItems: JSON.stringify(fields.extraItems)
      },
      success: function (resp) {
        // Ignore anything but the newest request.
        if (requestId !== estimateRequestId) return;

        if (resp && resp.success) {
          // Anything the server could not add must stop being offered as selected,
          // otherwise the confirmation row claims a gift that is not in the basket
          // and will not be charged. No re-query needed: the response already
          // reflects a basket without the skipped item.
          deselectSkippedItems(resp.skippedSkus);
          callback(resp);
        } else {
          // Keep the last good figures rather than showing the shopper $0.00,
          // but say so - they may no longer match the current selection.
          callback(lastEstimate, true);
        }
        setSummarySkeletonLoading(false);
      },
      error: function () {
        if (requestId !== estimateRequestId) return;
        callback(lastEstimate, true);
        setSummarySkeletonLoading(false);
      }
    });
  }

  // Listen for changes
  function registerTaxShippingListeners() {
    var $billingAddress = $('#billingAddress');
    var $billingAddress2 = $('#billingAddress2');
    var $billingZip = $('#billingZip');
    var $billingCountry = $('#billingCountry');
    var $shippingAddress = $('input[name="shippingAddress"]');
    var $shippingAddress2 = $('input[name="shippingAddress2"]');
    var $shippingZip = $('input[name="shippingZip"]');
    var $shippingCountry = $('#shippingCountry');
    var $quantity = $('.checkout-widget .quantity-input');
    var $sku = $('input.productId');
    var $useSameAsBilling = $('#useSameAsBilling');

    // Debounce utility
    function debounce(func, wait) {
      var timeout;
      var debounced = function() {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          func.apply(context, args);
        }, wait);
      };
      // Lets callers that need to run immediately drop a pending trailing call.
      debounced.cancel = function () {
        clearTimeout(timeout);
      };
      return debounced;
    }

    function maybeQueryDebounced() {
      var fields = getTaxShippingFields();
      // ...existing code...
      if (hasAllTaxShippingFields(fields)) {
        queryTaxAndShipping(fields, function (estimate, isStale) {
          renderSummary(estimate, isStale);
          setSummarySkeletonLoading(false);
        });
      } else {
        // Not enough address entered to price anything yet. Invalidate any request
        // still in flight so its (now outdated) response cannot repaint, and mark
        // carried-over figures stale - they predate the current selection.
        estimateRequestId += 1;
        renderSummary(lastEstimate, !!lastEstimate);
        setSummarySkeletonLoading(false);
      }
    }

    function maybeQuery() {
      setSummarySkeletonLoading(true);
      maybeQuery._debounced();
    }
    maybeQuery._debounced = debounce(maybeQueryDebounced, 1000);
    window.maybeQuery = maybeQuery;

    // Discrete choices (picking a gift amount, removing it) should not sit behind
    // the 1s debounce that exists for address typing. Cancel any pending
    // debounced call so it cannot fire a second, redundant request afterwards.
    function maybeQueryNow() {
      setSummarySkeletonLoading(true);
      maybeQuery._debounced.cancel();
      maybeQueryDebounced();
    }
    window.maybeQueryNow = maybeQueryNow;

    $billingAddress.on('input change', maybeQuery);
    $billingAddress2.on('input change', maybeQuery);
    $billingZip.on('input change', maybeQuery);
    $billingCountry.on('change', maybeQuery);

    function shippingChangedHandler() {
      if ($useSameAsBilling.is(':checked')) {
        if (typeof window.copyValuesToBilling === 'function') {
          window.copyValuesToBilling();
        } else if (typeof copyValuesToBilling === 'function') {
          copyValuesToBilling();
        }
      }
      maybeQuery();
    }

    $shippingAddress.on('input change', shippingChangedHandler);
    $shippingAddress2.on('input change', shippingChangedHandler);
    $shippingZip.on('input change', shippingChangedHandler);
    $shippingCountry.on('change', shippingChangedHandler);

    $quantity.on('input change', maybeQuery);
    $sku.on('change', maybeQuery);
    $useSameAsBilling.on('change', function() {
      console.log('change!')
      if(!$useSameAsBilling.is(':checked')) {
        // If unchecking, do not copy values
        console.log('unchecked!');
        return;
      }
      copyValuesToBilling();
      maybeQuery();
    });
  }

  // Register listeners
  registerTaxShippingListeners();
}

/**
 * Renders the summary from an estimate response.
 *
 * Item rows are rebuilt from estimate.lineItems rather than written into a fixed
 * row, because `subtotal` covers every line in the basket - once an add-on is
 * present, writing subtotal into the product row would label the combined figure
 * with the product's name.
 *
 * @param {Object|null} estimate - a WidgetGetTaxEstimate response, or null before
 *                                 the first successful call
 * @param {boolean} [isStale] - true when the request failed and these figures are
 *                              carried over from a previous response
 */
function renderSummary(estimate, isStale) {
  var data = estimate || {};

  var subtotalNum = toAmount(data.subtotal);
  var taxesNum = toAmount(data.taxes);
  var shippingNum = data.shippingCost === 'FREE' ? 0.00 : toAmount(data.shippingCost);
  var total = typeof data.total === 'number' ? data.total : subtotalNum + taxesNum + shippingNum;

  var formattedShipping = shippingNum <= 0 ? 'FREE' : '$' + shippingNum.toFixed(2);
  var formattedTotal = total.toFixed(2);

  renderSummaryLineItems(data.lineItems, subtotalNum);

  $('.checkout-widget .tax-value').text(taxesNum.toFixed(2));
  $('.checkout-widget .shipping-value').text(formattedShipping);
  $('.checkout-widget .total-value').text(formattedTotal);
  $('.checkout-widget .summary-header-total').text('$' + formattedTotal);

  var each = data.each;
  if (each != null && each !== "" && each !== 0) {
    $('.quantity .book-price').text(each + " each");
  }

  // Only cache responses that actually carry figures, so a failed request that
  // re-renders from cache cannot overwrite the cache with nothing.
  if (!isStale && estimate && estimate.lineItems) {
    lastEstimate = estimate;
  }

  $('.checkout-widget .summary-error').toggle(!!isStale);
}

function toAmount(value) {
  if (typeof value === 'number') return value;
  return parseFloat(value) || 0.00;
}

/**
 * Summary label for an add-on. Donation variants carry catalog names like
 * "DON-USA-OTG-20", so the display label comes from the markup's data-label
 * ("One-Time Gift") and falls back to the catalog name.
 *
 * @param {string} sku - the add-on's SKU
 * @param {string} fallback - product name from the estimate response
 * @returns {string} label to show in the summary
 */
function getExtraItemLabel(sku, fallback) {
  var el = $('.checkout-widget [data-extra-item]').filter(function () {
    return $(this).data('sku') === sku;
  }).first();

  return (el.length && el.data('label')) ? el.data('label') : fallback;
}

/**
 * Rebuilds the item rows above the summary divider, one per basket line item.
 *
 * @param {Array} lineItems - line items from the estimate response
 * @param {number} subtotalNum - fallback amount for the first-paint row
 */
function renderSummaryLineItems(lineItems, subtotalNum) {
  var container = $('.checkout-widget .summary-line-items');
  if (!container.length) return;

  // No response yet: leave the server-rendered placeholder row in place and just
  // fill in its amount, so the product name stays visible during first paint.
  if (!lineItems || !lineItems.length) {
    container.find('.item-subtotal-value').text(subtotalNum.toFixed(2));
    return;
  }

  // Row amounts are line totals, so quantity is not repeated here - it already
  // has its own section above, and the wireframe shows name + amount only.
  var rows = lineItems.map(function (item) {
    var label = item.role === 'main' ? item.name : getExtraItemLabel(item.sku, item.name);

    return $('<div/>', { 'class': 'summary-item' })
      .append($('<span/>', { 'class': 'summary-label', text: label }))
      .append($('<span/>', { 'class': 'summary-value item-price', text: '$' + toAmount(item.price).toFixed(2) }));
  });

  container.empty().append(rows);
}

